export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/decor-tax.a7d5ab05-cea971.svg";